var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"shadow-md py-16",class:_vm.backgroundColor},[_c('div',{staticClass:"full lg:w-4/5 mx-auto"},[_c('h2',{staticClass:"text-4xl mb-4 text-center",class:_vm.textColor},[_vm._t("title")],2),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }